<template>
  <v-container fluid>
    <v-layout row wrap>
      <!-- Header -->
      <v-flex xs12 class="d-flex justify-space-between mb-3 align-center">
        <h3>Country Wise Departure  <span class="font-weight-bold">{{purpose}}</span>  Report</h3>

        <div class="text-xs-right">
          <export-summary-report-button
              v-if="$oauth.checkIfHasPermission(['export departure-purpose-summary-report'])"
              model="departure-purpose-country-wise"
              :export-date="range"
              :export-purpose="purpose"
          />
          <refresh-button :click-function="departurePurposeSummaryReport" />
        </div>
      </v-flex>

      <!-- Filters & Table -->
      <v-flex xs12>
        <v-card>
          <!-- Filters -->
          <v-layout row wrap class="py-1 mx-2">
            <v-flex xs3 class="d-flex align-center">
              <custom-date-range-picker
                  v-model="range"
                  @change="departurePurposeSummaryReport"
              />
            </v-flex>
          </v-layout>

          <v-divider />

          <!-- Table -->
          <v-card-text class="pa-0">
            <v-simple-table
                v-if="$oauth.checkIfHasPermission(['read departure-purpose-summary-report'])"
            >
              <thead>
              <tr>
                <th class="text-center">S.N</th>
                <th class="text-left">Country Name</th>
                <th class="text-left">Male Traveller</th>
                <th class="text-left">Female Traveller</th>
                <th class="text-left">Other Traveller</th>
                <th class="text-center">Total Traveller</th>
              </tr>
              </thead>

              <v-overlay :value="progressLinearLoading">
                <v-progress-circular indeterminate size="64" />
              </v-overlay>

              <tbody v-if="departure_purpose_data.length">
              <tr v-for="(item, i) in departure_purpose_data" :key="i">
                <td class="text-center">{{ i + 1 }}</td>
                <td class="text-left">{{ item.country_name }}</td>
                <td class="text-left">{{ item.male_traveller }}</td>
                <td class="text-left">{{ item.female_traveller }}</td>
                <td class="text-left">{{ item.other_traveller }}</td>
                <td class="text-center font-weight-bold">
                  {{ item.total_traveller }}
                </td>
              </tr>
              </tbody>

              <tbody v-else>
              <tr>
                <td colspan="3" class="text-center">No record found</td>
              </tr>
              </tbody>

              <tfoot>
              <tr>
                <td class="text-center">#</td>
                <td class="text-left font-weight-bold">Total</td>
                <td class="text-left font-weight-bold">{{totalMaleTraveller}}</td>
                <td class="text-left font-weight-bold">{{totalFemaleTraveller}}</td>
                <td class="text-left font-weight-bold">{{totalOtherTraveller}}</td>
                <td class="text-center font-weight-bold">
                  {{ totalTraveller }}
                </td>
              </tr>
              </tfoot>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import { VERSIONED_API_URL } from "../../config/config";

import CustomDateRangePicker from "@/components/CustomDateRangePicker";
import ExportSummaryReportButton from "@/components/ExportSummaryReportButton";
import RefreshButton from "@/components/RefreshButton";
import { commonStoreMixin } from "@/mixins/commonStoreMixin";

export default {
  name: "CountryWiseDeparturePurposeViewReport",

  components: {
    CustomDateRangePicker,
    ExportSummaryReportButton,
    RefreshButton,
  },

  mixins: [commonStoreMixin],

  data() {
    return {
      departure_purpose_data: [],
      range: {
        start: null,
        end: null,
      },
      progressLinearLoading: false,
    };
  },

  computed: {
    ...mapGetters({
      countries: "CountryList/all",
    }),
    purpose() {
      return this.$route.params.purpose || '';
    },

    totalTraveller() {
      return this.departure_purpose_data.reduce(
          (sum, item) => sum + Number(item.total_traveller || 0),
          0
      );
    },
    totalMaleTraveller() {
      return this.departure_purpose_data.reduce(
          (sum, item) => sum + Number(item.male_traveller || 0),
          0
      );
    },
    totalFemaleTraveller() {
      return this.departure_purpose_data.reduce(
          (sum, item) => sum + Number(item.female_traveller || 0),
          0
      );
    },
    totalOtherTraveller() {
      return this.departure_purpose_data.reduce(
          (sum, item) => sum + Number(item.other_traveller || 0),
          0
      );
    },
  },

  methods: {
    ...mapActions({
      fetchCountries: "CountryList/fetchAllCountries",
    }),

    departurePurposeSummaryReport() {
      this.progressLinearLoading = true;

      axios
          .get(
              `${VERSIONED_API_URL}/summary-report/departure-purpose/view`,
              {
                params: {
                  purpose: this.purpose,
                  start_date: this.range.start,
                  end_date: this.range.end,
                },
              }
          )
          .then((res) => {
            this.departure_purpose_data = res.data.data || [];
          })
          .catch(() => {
            this.$store.commit(
                "Notification/showError",
                "Something went wrong"
            );
          })
          .finally(() => {
            this.progressLinearLoading = false;
          });
    },
  },

  mounted() {
    const today = new Date().toISOString().substr(0, 10);

    this.range = {
      start: today,
      end: today,
    };

    if (!this.countries.length) {
      this.fetchCountries();
    }

    this.departurePurposeSummaryReport();
  },
};
</script>
